module.exports = __webpack_public_path__ + "media/images/brands/lilica_e_tigor2-7c8765e7cc907565dfc601f8258cca88.png";